import { Snippet } from '../../dataModels';

export const snippetGroupSnippet: Snippet = {
  shiftsummaryDisplyId: '00000000-0000-0000-0000-000000000000',
  name: 'AA_Group',
  displayName: 'AA_Group',
  description: null,
  order: 1,
  type: 'snippetGroup',
  count: 4,
  enableEdit: 'True',
  enableComment: true,
  isEdited: false,
  maxRows: 0,
  canAddDeleteRows: 'False',
  configuration: null,
  data: null,
  groupSnippets: [
    {
      displayTemplateId: '1eaddead-5875-ec11-913d-005056b2dead',
      shiftsummaryDisplyId: 'ca9ecf6b-5875-ec11-913d-005056b29cce',
      name: 'AA_Com',
      displayName: 'AA_Com',
      description: null,
      order: 1,
      type: 'Comment',
      count: 0,
      enableEdit: 'True',
      enableComment: true,
      isEdited: false,
      maxRows: 5,
      canAddDeleteRows: 'False',
      configuration: null,
      data: [
        {
          rollupDetails: null,
          rowCount: 1,
          rowData: [
            {
              Note: '',
            },
          ],
        },
      ],
      groupSnippets: null,
    },
    {
      displayTemplateId: '2eaddead-5875-ec11-913d-005056b2dead',
      shiftsummaryDisplyId: 'cb9ecf6b-5875-ec11-913d-005056b29cce',
      name: 'User Info',
      displayName: 'YJ_DET',
      description: null,
      order: 2,
      type: 'DataEntryTable',
      count: 0,
      enableEdit: 'True',
      enableComment: true,
      isEdited: false,
      maxRows: 5,
      canAddDeleteRows: 'False',
      configuration: {
        rowTitleKey: 'EquipmentName',
        matrixCells: null,
        columnCount: 3,
        columns: [
          {
            id: 1,
            name: 'EquipmentName',
            displayName: 'Equipment name',
            controlType: 'Text',
            controlValues: null,
            visible: 'True',
          },
          {
            id: 2,
            name: 'InService',
            displayName: 'Is already in service',
            controlType: 'Checkbox',
            controlValues: null,
            visible: 'True',
          },
          {
            id: 3,
            name: 'DateToService',
            displayName: 'Date to service',
            controlType: 'DateTime',
            controlValues: null,
            visible: 'True',
          },
          {
            id: 4,
            name: 'Count',
            displayName: 'Count',
            controlType: 'Numeric',
            controlValues: null,
            visible: 'True',
          },
        ],
      },
      data: [
        {
          rollupDetails: null,
          rowCount: 0,
          rowData: [],
        },
      ],
      groupSnippets: null,
    },
    {
      displayTemplateId: '3eaddead-5875-ec11-913d-005056b2dead',
      shiftsummaryDisplyId: '0e601885-bbf3-ec11-9147-005056b29cce',
      name: 'AAA_Mat',
      displayName: 'AAA_Mat',
      description: null,
      order: 4,
      type: 'Matrix',
      enableEdit: 'True',
      enableComment: true,
      isEdited: false,
      maxRows: 5,
      canAddDeleteRows: 'False',
      configuration: {
        rowTitleKey: 'Column header 1',
        columnCount: 3,
        columns: [
          {
            id: 1,
            name: 'Column header 1',
            displayName: 'Column header 1',
            controlType: 'Checkbox',
            controlValues: null,
            visible: 'True',
          },
          {
            id: 2,
            name: 'Column header 2',
            displayName: 'Column header 2',
            controlType: 'Text',
            controlValues: null,
            visible: 'True',
          },
          {
            id: 3,
            name: 'Column header 3',
            displayName: 'Column header 3',
            controlType: 'DateTime',
            controlValues: null,
            visible: 'True',
          },
        ],
        matrixCells: [
          {
            rowNumber: 1,
            colNumber: 1,
            controlType: 'Checkbox',
            controlValues: null,
          },
          {
            rowNumber: 2,
            colNumber: 1,
            controlType: 'Checkbox',
            controlValues: null,
          },
          {
            rowNumber: 1,
            colNumber: 2,
            controlType: 'Text',
            controlValues: null,
          },
          {
            rowNumber: 1,
            colNumber: 3,
            controlType: 'Numeric',
            controlValues: null,
          },
          {
            rowNumber: 2,
            colNumber: 2,
            controlType: 'Text',
            controlValues: null,
          },
          {
            rowNumber: 2,
            colNumber: 3,
            controlType: 'DateTime',
            controlValues: null,
          },
        ],
      },
      data: [
        {
          rollupDetails: null,
          rowCount: 2,
          rowData: [
            {
              'Column header 1': 'False',
              'Column header 2': null,
              'Column header 3': 123892,
            },
            {
              'Column header 1': 'True',
              'Column header 2': 'Test Field 1',
              'Column header 3': '2022-06-24T03:00:00Z',
            },
          ],
        },
      ],
      count: 0,
      groupSnippets: null,
    },
    {
      displayTemplateId: '4eaddead-5875-ec11-913d-005056b2dead',
      shiftsummaryDisplyId: 'c99ecf6b-5875-ec11-913d-005056b29cce',
      name: 'AA_Table',
      displayName: 'AA_Table',
      description: null,
      order: 4,
      type: 'Table',
      count: 0,
      enableEdit: 'True',
      enableComment: true,
      isEdited: false,
      maxRows: 5,
      canAddDeleteRows: 'False',
      configuration: {
        rowTitleKey: 'Name',
        columnCount: 5,
        matrixCells: null,
        columns: [
          {
            id: 1,
            name: 'Name',
            displayName: 'Name',
            controlType: 'Text',
            controlValues: null,
            visible: 'True',
          },
          {
            id: 2,
            name: 'Description',
            displayName: 'Description',
            controlType: 'Text',
            controlValues: null,
            visible: 'True',
          },
          {
            id: 3,
            name: 'DisplayName',
            displayName: 'DisplayName',
            controlType: 'Text',
            controlValues: null,
            visible: 'True',
          },
          {
            id: 4,
            name: 'Asset_PK_ID',
            displayName: 'Asset_PK_ID',
            controlType: 'Text',
            controlValues: null,
            visible: 'True',
          },
          {
            id: 5,
            name: 'EquipID',
            displayName: 'EquipID',
            controlType: 'Text',
            controlValues: null,
            visible: 'True',
          },
        ],
      },
      data: [
        {
          rollupDetails: null,
          rowCount: 20,
          rowData: [
            {
              Name: 'A1_FIELD',
              Description: '',
              DisplayName: 'A1_FIELD',
              Asset_PK_ID: '5f579b3c-36b8-42b1-b6ab-290c43b1d416',
              EquipID: '42732c6b-c520-4102-97ff-6907a017a900',
            },
            {
              Name: 'A2/3_FIELD',
              Description: '',
              DisplayName: 'A2/3_FIELD',
              Asset_PK_ID: 'f00d5e5e-8a75-458a-8f06-1c7b63567897',
              EquipID: '0f034c0c-3898-4ce0-9c56-1b8a1642c7ed',
            },
            {
              Name: 'AROM',
              Description: 'AROM',
              DisplayName: 'AROM',
              Asset_PK_ID: '92307e7b-28ec-4221-8153-52c7b6f328da',
              EquipID: '84a32799-d374-4cad-9444-6cbc8bb06622',
            },
            {
              Name: 'AROM_CONSOLE',
              Description: '',
              DisplayName: 'AROM_CONSOLE',
              Asset_PK_ID: '24356226-37d6-460d-ad01-ceccd9222c94',
              EquipID: 'f78171f3-92b8-47d3-8535-e2a184debbb0',
            },
            {
              Name: 'BE1_FIELD',
              Description: '',
              DisplayName: 'BE1_FIELD',
              Asset_PK_ID: 'fd2114d0-1817-49dd-916e-868b00760933',
              EquipID: '9f8bef87-96a8-4081-8fc8-0a13a9987730',
            },
            {
              Name: 'BE2_FIELD',
              Description: '',
              DisplayName: 'BE2_FIELD',
              Asset_PK_ID: 'd98bed27-fac5-4346-93e6-71cbab9104c7',
              EquipID: '5108e7f8-0245-4c49-a7be-2f3fcdc2024a',
            },
            {
              Name: 'BTR_Test',
              Description: '',
              DisplayName: 'BTR_Test',
              Asset_PK_ID: 'a0e94755-f95b-4a91-bf8e-754b6ce2d93c',
              EquipID: '85819d7f-7f7c-4ca4-9614-86b0b10e0822',
            },
            {
              Name: 'BusTeam1',
              Description: '',
              DisplayName: 'BusTeam1',
              Asset_PK_ID: 'b5fdc959-7d8a-4673-831c-36f1f8c63b07',
              EquipID: '48eb99de-cf9b-4dba-8904-f26b0b60eade',
            },
            {
              Name: 'BusTeam2',
              Description: '',
              DisplayName: 'BusTeam2',
              Asset_PK_ID: 'e00329a2-64aa-423d-9215-114933f411db',
              EquipID: '00000000-0000-0000-0000-000000000000',
            },
            {
              Name: 'C1_CONSOLE',
              Description: 'CONDY1_CONSOLE',
              DisplayName: 'CONDY1_CONSOLE',
              Asset_PK_ID: '2d2805eb-541b-468c-9bc6-738e8f1b4cb5',
              EquipID: '17e55b62-20c0-49a1-aa52-ce650f3210b3',
            },
            {
              Name: 'C1_FIELD',
              Description: '',
              DisplayName: 'C1_FIELD',
              Asset_PK_ID: '3a6b9de1-65f6-415a-a31e-dec33a0b3ecc',
              EquipID: 'd81ba349-e920-4fb3-83b9-e12df66621cc',
            },
            {
              Name: 'C2_CONSOLE',
              Description: 'CONDY2_CONSOLE',
              DisplayName: 'CONDY2_CONSOLE',
              Asset_PK_ID: 'd3fb716a-aa94-498f-88c7-899809fcfac2',
              EquipID: 'ef155b27-fa54-4072-bb59-739d9dd46075',
            },
            {
              Name: 'C2_FIELD',
              Description: '',
              DisplayName: 'C2_FIELD',
              Asset_PK_ID: '988e7c6d-d02b-425d-a2c5-b19d931a0b05',
              EquipID: 'a468a470-f769-4675-99d4-7482a0a89ba5',
            },
            {
              Name: 'CONDY',
              Description: 'CONDY',
              DisplayName: 'CONDY',
              Asset_PK_ID: 'e1828aba-c583-e811-80de-005056aa75e7',
              EquipID: '1d7e4224-f630-4d55-93f7-5ad93b1d6ca7',
            },
            {
              Name: 'Console1',
              Description: '',
              DisplayName: 'Console1',
              Asset_PK_ID: 'c88437d7-c511-401b-bce5-725ba6755989',
              EquipID: '8d1dcc99-4dab-4e63-b760-ed0bbf33c93d',
            },
            {
              Name: 'Console2',
              Description: '',
              DisplayName: 'Console2',
              Asset_PK_ID: '51b78eb9-4cd3-4982-a3e7-901094dc82c9',
              EquipID: '00000000-0000-0000-0000-000000000000',
            },
            {
              Name: 'CORY',
              Description: '',
              DisplayName: 'CORY',
              Asset_PK_ID: '58c75a01-e154-e811-80da-005056aa75e7',
              EquipID: '480944e6-a4fe-4902-a6c5-58b09166f23e',
            },
            {
              Name: 'DAP Arom',
              Description: '',
              DisplayName: 'DAP Arom',
              Asset_PK_ID: '59c65572-9bd7-47bf-9746-32f3f31830f9',
              EquipID: '84e51429-ef15-4f85-ad05-d4b50bbb0a47',
            },
            {
              Name: 'DAP Crude',
              Description: '',
              DisplayName: 'DAP Crude',
              Asset_PK_ID: '8d62ca04-5763-ea11-910a-005056b29cce',
              EquipID: 'b7764b57-d3bd-4539-8c42-f8e09ecd4d60',
            },
            {
              Name: 'DAP Gasoil',
              Description: '',
              DisplayName: 'DAP Gasoil',
              Asset_PK_ID: '0a18e6b9-dd3c-47bd-9fb9-59fad9733f4c',
              EquipID: '566f7b7a-7d08-4c35-a15c-a60548329e9f',
            },
          ],
        },
      ],
      groupSnippets: null,
    },
  ],
};
